import _extends from "@babel/runtime/helpers/esm/extends";
import { createSearchParams, generatePath, matchPath } from './internal';

// eslint-disable-next-line @typescript-eslint/default-param-last
function omit(obj = {}, keys) {
  const result = _extends({}, obj);
  keys.forEach(key => {
    delete result[key];
  });
  return result;
}

/**
 * Returns the location to navigate.
 *
 * @param pattern route configured by module.
 * @param params dynamic parameters we want to set.
 * @returns pathname and search
 *
 * @example
 * const to = getNavigateTo('/patients/:id/:section', {
 *   id: '123',
 *   section: 'chat',
 *   date: '11/11/2022',
 * });
 *
 * // returns
 * {
 *   pathname: '/patients/123/chat',
 *   search:   '?date=11/11/2022',
 * }
 */
export default function getNavigateTo(pattern, params) {
  const pathname = pattern && generatePath(pattern, params);
  if (!pattern || !pathname) {
    return {
      search: `?${createSearchParams(params).toString()}`
    };
  }
  const info = matchPath(pattern, pathname);
  const keysParsed = Object.keys((info == null ? void 0 : info.params) || {});
  const search = omit(params, keysParsed);
  return {
    pathname,
    search: `?${createSearchParams(search).toString()}`
  };
}